/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum HeaderAnimationEnum {
  FADE = "fade",
  SWIPE = "swipe",
  MARQUEE = "marquee",
}
